/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { domainsRegisterDomain } from "../funcs/domainsRegisterDomain.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { CustomDomain } from "../models/components/customdomain.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  RegisterDomainRequest,
  RegisterDomainSecurity,
} from "../models/operations/registerdomain.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type RegisterDomainMutationVariables = {
  request: RegisterDomainRequest;
  security?: RegisterDomainSecurity | undefined;
  options?: RequestOptions;
};

export type RegisterDomainMutationData = CustomDomain;

export type RegisterDomainMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * createDomain domains
 *
 * @remarks
 * Create a custom domain for an organization
 */
export function useRegisterDomainMutation(
  options?: MutationHookOptions<
    RegisterDomainMutationData,
    RegisterDomainMutationError,
    RegisterDomainMutationVariables
  >,
): UseMutationResult<
  RegisterDomainMutationData,
  RegisterDomainMutationError,
  RegisterDomainMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildRegisterDomainMutation(client, options),
    ...options,
  });
}

export function mutationKeyRegisterDomain(): MutationKey {
  return ["@gram/client", "domains", "registerDomain"];
}

export function buildRegisterDomainMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: RegisterDomainMutationVariables,
  ) => Promise<RegisterDomainMutationData>;
} {
  return {
    mutationKey: mutationKeyRegisterDomain(),
    mutationFn: function registerDomainMutationFn({
      request,
      security,
      options,
    }): Promise<RegisterDomainMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(domainsRegisterDomain(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
